module.exports = __webpack_public_path__ + "static/media/ic_play.7bb93f42.png";